import { jsx as e, jsxs as h } from "react/jsx-runtime";
import { Modal as k, PrimaryButton as B, SecondaryButton as E, FieldErrorAndDescription as I } from "@systemeio/ui";
import { useState as l } from "react";
import { useTranslation as S } from "../../i18n.mjs";
import { twMerge as u } from "tailwind-merge";
function D({
  opened: w,
  onClose: n,
  onConfirm: x,
  onDecline: r,
  title: o,
  confirmationText: c = "",
  className: y,
  cancelButtonCaption: C,
  confirmButtonCaption: _,
  buttonClassName: f,
  buttonTextClassName: m,
  confirmationContent: N,
  afterLeave: d
}) {
  const { t } = S(), [j, g] = l(""), [i, s] = l(!1), [v, p] = l(!1), M = async () => {
    try {
      s(!0), await x(), s(!1), p(!0);
    } catch {
      s(!1), g(t("file_manager.something_went_wrong"));
    }
  }, F = () => {
    g(""), p(!1);
  };
  return /* @__PURE__ */ e(
    k,
    {
      opened: w,
      onClose: () => {
        !v && r && r(), n();
      },
      title: o || t("file_manager.confirm_action"),
      afterLeave: () => {
        d && d(), F();
      },
      isFetching: i,
      isCentered: !0,
      className: y,
      children: /* @__PURE__ */ h("form", { className: "flex flex-col gap-6 lg:gap-10", children: [
        c && /* @__PURE__ */ e("div", { className: "flex justify-center", children: /* @__PURE__ */ e("p", { className: "text-text-primary text-base", children: c }) }),
        N,
        /* @__PURE__ */ h("div", { className: "flex justify-center gap-4", children: [
          /* @__PURE__ */ e(
            B,
            {
              isFetching: i,
              className: u("w-full", f),
              buttonTextClassName: m,
              width: "large",
              onClick: async (a) => {
                a.preventDefault(), await M();
              },
              type: "submit",
              children: _ || t("file_manager.confirm")
            }
          ),
          /* @__PURE__ */ e(
            E,
            {
              className: u("w-full", f),
              width: "large",
              buttonTextClassName: m,
              onClick: (a) => {
                a.preventDefault(), r && r(), n();
              },
              disabled: i,
              children: C || t("file_manager.cancel")
            }
          )
        ] }),
        /* @__PURE__ */ e(I, { error: j, errorClassName: "text-center" })
      ] })
    }
  );
}
export {
  D as ConfirmationModal
};
